import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../../store/actions/notificationAction';;

import User from '../../../../models/User';
import ApiResponse from '../../../../models/ApiResponse';
import ResponseError from '../../../../models/ResponseError';

import moment, { Moment } from 'moment';
import DriverCheckin from './DriverCheckin';

interface DriverETAOfflineContainerProps {
  user: User;
  history: any;
  match: { params: { number: string, secretKey: string } };
  receiveError: (error: ResponseError) => void;
  receiveSuccess: (message: string) => void;
};

interface DriverETAOfflineContainerState {
  dooNumber: number;
  secretKey: string;
  dropOffTimeError: boolean;
  tabValue: number;
  setETAAuto: boolean;
  userLocation: { lat: number, lng: number } | null;
  destination: { lat: number, lng: number } | null;
  durationValue: number;
  arrivalTime: Date;
  arrivesIn: string;
  eta: string
};

class DriverETAOfflineContainer extends Component<DriverETAOfflineContainerProps, DriverETAOfflineContainerState> {

  state = {
    dooNumber: 0,
    secretKey: '',
    dropOffTimeError: false,
    tabValue: 0,
    userLocation: null,
    destination: null,
    setETAAuto: false,
    durationValue: 0,
    arrivalTime: new Date(),
    arrivesIn: '',
    eta: ''
  }

  componentDidMount() {

    this.load();
  }

  load = (): void => {
    const dooNumber: number = parseInt(this.props.match.params.number);
    const secretKey: string = this.props.match.params.secretKey;
  };

  setETADriver = (time: string): void => {
  };

  selectETA = (): void => {

    const currState: DriverETAOfflineContainerState = { ...this.state };
    const dooNumber: Number = currState.dooNumber;
    const secretKey: string = currState.secretKey;
    
    if (dooNumber && secretKey) {
      this.props.history.push(`/drv-map/do/${dooNumber}/${secretKey}`);
    }
  }

  handleDropOffTimeChange = (dateTime: Moment): void => {


  }

  changeEta = (event: any): void => {
    const time: any = event;
    this.setState({ arrivalTime: time });
    
  }

  handleChange = (event: any, newValue: number) => {

  };

   handleUpdate = async (type: string): Promise<void> => {

    //console.log('handleUpdate')
      
  }

  render() {

    return (
      <DriverCheckin
        handleChange={ this.handleChange }
       
      />
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (message: string) => dispatch(receiveSuccess(message))
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(DriverETAOfflineContainer);